// import Vue from 'vue'
/* eslint-disable */
import { createWebHistory, createRouter } from 'vue-router';
import { trackRouter } from "vue-gtag-next";
import { useAuthStore } from "@/stores";
import { mainServices } from "@/services/mainServices";

// import HomePage from '@/pages/HomePage';
import InsuranceNavigatorPage from '@/pages/InsuranceNavigatorPage';
import ReviewAndSendToPlanPage from '@/pages/ReviewAndSendToPlanPage';
// import SignUp from '@/pages/SignUp';
import CompleteRegistration from '@/pages/CompleteRegistration';
import SignIn from '@/pages/SignIn';
import PasswordResetRequest from '@/pages/PasswordResetRequest';
import PasswordReset from '@/pages/PasswordReset';
import ConfirmEmail from '@/pages/ConfirmEmail';
import ReviewInitiatedPriorAuthPage from '@/pages/ReviewInitiatedPriorAuthPage';
import HealthCheckView from '@/pages/HealthCheckView.vue';
import PatientIntakeReview from './pages/PatientIntakeReview.vue';
import PatientIntakeQualifyPatient from './pages/PatientIntakeQualifyPatient.vue';
import PatientIntakeClinicalReview from './pages/PatientIntakeClinicalReview.vue';
import OrderDenialFollowUp from './pages/OrderDenialFollowUp.vue';
import IntakeOpsReview from './pages/IntakeOpsReview.vue';
import OpsUtilities from './pages/OpsUtilities.vue';
import CreateSubmissionView from '@/pages/CreateSubmissionView.vue';
import HealthMonitoring from '@/pages/HealthMonitoring.vue';
import ImportCMMSubmissionPage from '@/pages/ImportCMMSubmissionPage.vue';
import PromptFeedbackTriage from '@/pages/PromptFeedbackTriage.vue';
import PromptTuningQueue from '@/pages/PromptTuningQueue.vue';
import PromptTuningDetail from '@/pages/PromptTuningDetail.vue';

const publicAccessRoutes = [
  // {
  //   path: "/register",
  //   name: "register",
  //   component: SignUp,
  //   title: "Do Prior Auth",
  // },
  {
    path: "/complete-registration/:user_id?/:token?",
    name: "complete-registration",
    component: CompleteRegistration,
    title: "Do Prior Auth",
  },
  {
    path: "/login",
    name: "login",
    component: SignIn,
    title: "Do Prior Auth",
  },
  {
    path: "/password-reset-request",
    name: "password-reset-request",
    component: PasswordResetRequest,
    title: "Password Reset",
  },
  {
    path: "/confirm-email/:user_id/:token",
    name: "confirmEmail",
    component: ConfirmEmail,
    title: "Do Prior Auth",
  },
  {
    path: "/password-reset/:token?",
    name: "password-reset",
    component: PasswordReset,
    title: "Password Reset",
  },
  {
    path: "/health-check",
    name: "health-check",
    component: HealthCheckView,
    title: "Health Check",
  }
];

const protectedRoutes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/pages/PATablePage.vue"),
    title: "Prior Auth",
  },
  {
    path: "/check-my-coverage/:id?",
    name: "check-my-coverage",
    component: ReviewAndSendToPlanPage,
    title: "Insurance Criteria",
  },
  {
    path: "/access-initiated-prior-auth/:id",
    name: "access-initiated-prior-auth",
    component: ReviewInitiatedPriorAuthPage,
    title: "Access Initiated Prior Authorization",
  },
  {
    path: '/all-submissions',
    name: 'all-submissions',
    redirect: '/prior-auth',
  },
  {
    path: '/create-submission/:id?',
    name: 'create-submission',
    component: CreateSubmissionView,
    title: "Create Submission"
  },
  {
    path: "/all-patients",
    name: "all-patients",
    redirect: "/intake",
  },
  {
    path: "/intake-review/:id",
    name: "intake-review",
    component: PatientIntakeReview,
    title: "Intake Review",
  },
  {
    path: "/intake/order/:id/qualify",
    name: "qualify-order",
    component: PatientIntakeQualifyPatient,
    title: "Qualify Patient",
  },
  {
    path: "/intake/order/:id/document-review",
    name: "document-review-order",
    component: PatientIntakeClinicalReview,
    title: "Document Review",
  },
  {
    path: "/order/:id/denial-follow-up",
    name: "denial-follow-up-order",
    component: OrderDenialFollowUp,
    title: "Denial Follow Up",
  },
  {
    path: "/ops-review/intake-document/:key",
    name: "ops-review-intake-document",
    component: IntakeOpsReview,
    title: "Intake Ops Review",
  },
  {
    path: "/ops-utilities",
    name: "ops-utilities",
    component: OpsUtilities,
    title: "Ops Utilities",
  },
  {
    path: "/monitoring",
    name: "monitoring",
    component: HealthMonitoring,
    title: "API Monitoring",
  },
  {
    path: "/ops/prompt-tuning/triage",
    name: "prompt-tuning-triage",
    component: PromptFeedbackTriage,
    title: "Feedback Triage",
  },
  {
    path: "/ops/prompt-tuning",
    name: "prompt-tuning-queue",
    component: PromptTuningQueue,
    title: "Prompt Proposals",
  },
  {
    path: "/ops/prompt-tuning/:id",
    name: "prompt-tuning-detail",
    component: PromptTuningDetail,
    title: "Prompt Proposal",
  },
  {
    path: "/import-cmm-submission",
    name: "import-cmm-submission",
    component: ImportCMMSubmissionPage,
    title: "Import CMM Submission",
  },
  {
    path: "/voice-ai",
    name: "voice-ai",
    component: () => import("@/pages/VoiceAI.vue"),
    title: "Voice AI",
  },
  {
    path: "/intake",
    name: "intake",
    component: () => import("@/pages/IntakeTablePage.vue"),
    title: "Intake",
  },
  {
    path: "/prior-auth",
    name: "prior-auth",
    component: () => import("@/pages/PATablePage.vue"),
    title: "Prior Auth",
  },
];

// Demo mode is available in every environment (it's a sales/prospect feature).
// DemoWrapper snapshots & restores any real session so visiting /demo never logs
// a real user out, runs against a fake user with no staff/admin flags, and is
// marked noindex so crawlers skip it.
const demoRoutes = [
  {
    path: "/demo",
    component: () => import("@/demo/DemoWrapper.vue"),
    children: [
      { path: "", redirect: "/demo/prior-auth" },
      { path: "intake", name: "demo-intake", component: () => import("@/pages/IntakeTablePage.vue"), meta: { title: "Demo — Intake" } },
      { path: "prior-auth", name: "demo-prior-auth", component: () => import("@/pages/PATablePage.vue"), meta: { title: "Demo — Prior Auth" } },
      { path: "import-cmm-submission", name: "demo-import-cmm-submission", component: ImportCMMSubmissionPage, meta: { title: "Demo — Import CMM" } },
      // Detail pages are not available in demo — clicking a row stays on the dashboard
      { path: "check-my-coverage/:id?", name: "demo-check-my-coverage", redirect: "/demo/prior-auth" },
    ],
  },
];

for (const r of publicAccessRoutes) {
  r.meta = { title: r.title || 'Do Prior Auth' }
}

for (const r of protectedRoutes) {
  r.meta = { loginRequired: true, title: r.title || 'Do Prior Auth' }
}

const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: "active",
  routes: [...demoRoutes, ...publicAccessRoutes, ...protectedRoutes],
});

router.beforeEach(async (to, from) => {
  const authManager = useAuthStore();
  document.title = to.meta.title || "Do Prior Auth";

  // Demo mode: redirect non-demo routes to their demo equivalents
  if (from.path.startsWith("/demo") && !to.path.startsWith("/demo") && to.name) {
    const demoName = `demo-${to.name}`;
    if (router.hasRoute(demoName)) {
      return { name: demoName, params: to.params, query: to.query };
    }
  }

  if (!authManager.loggedIn && to.meta.loginRequired) {
    return { name: "login", query: { redirect: to.fullPath } };
  }
  if (to.name === "home" && authManager.loggedIn) {
    try {
      const config = await mainServices.getCurrentUserClientConfig();
      const page = config?.uiConfig?.defaultPostLoginPage || "prior-auth";
      if (page === "home" || !router.hasRoute(page)) {
        return { name: "prior-auth" };
      }
      return { name: page };
    } catch {
      // API call failed — likely an expired session. The axios interceptor
      // will have already attempted a token refresh and redirected to login
      // if the refresh also failed. If we reach here the user is being
      // sent to login, so we just guard against rendering the wrong page.
      if (!authManager.loggedIn) {
        return { name: "login", query: { redirect: to.fullPath } };
      }
      return { name: "prior-auth" };
    }
  }
});

trackRouter(router);

export default router;